import React, { useState, useEffect } from "react";
import { array, string } from "prop-types";

import NewsWithImage from "../../../molecules/NewsWithImage";
import WideStoryCard from "../../../molecules/WideStoryCard";

import "./organism1.m.css";

const Organism1 = ({ storyList, className = "" }) => {
  const [isMobile, setIsMobile] = useState(false);

  if (!(storyList && storyList.length)) {
    return null;
  }

  useEffect(() => {
    setIsMobile(global.deviceWidth < 876);
  });

  return (
    <div styleName="base" className={className}>
      <div styleName="lead-storycard">
        <WideStoryCard
          story={storyList[0].story}
          cssStyleName="semiBigSize"
          aspectRatio={[3, 2]}
          imageType="image3x2"
          excerptShow={false}
        />
      </div>
      {storyList.splice(1, storyList.length).map(({ story }, index) => (
        <div key={index} styleName={`story-${index + 1}`}>
          <NewsWithImage story={story} key={index} showExcerpt={!isMobile} />
        </div>
      ))}
    </div>
  );
};

Organism1.propTypes = {
  storyList: array.isRequired,
  className: string,
};

export default Organism1;
